import { AlertCategory, SystemType } from '@models/alerts-v2.model';
import { AlertEntry } from '../../development/alerts.service';
import { MapModalModels } from '@modals/map-modal/model/map-modal.models';
import MapCoords = MapModalModels.MapCoords;

export function isPanicAlertEntry(alert: AlertEntry | null | undefined): boolean {
  return alert?.category === AlertCategory.System && alert?.flowType === SystemType.Panic;
}

// Mirrors backend VariableReplacementTransactionsService.parseEventFields — the alert's
// `extra.event_fields` is a "key: value, key: value" string (see PanicAlertModel.BaseChannelParams).
export function extractPanicCoords(alert: AlertEntry | null | undefined): MapCoords | null {
  const eventFields = alert?.extra?.event_fields;
  if (!eventFields) {
    return null;
  }

  const fields: Record<string, string> = {};
  const regex = /(\w+):\s*(.*?)(?=,\s*\w+:|$)/gs;
  let match: RegExpExecArray | null;
  while ((match = regex.exec(eventFields)) !== null) {
    fields[match[1].trim()] = match[2].trim();
  }

  const lat = Number(fields['lat']);
  const lng = Number(fields['lng']);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return null;
  }

  return { lat, lng };
}
